module.exports = __webpack_public_path__ + "static/studio-07-3682ce50433648f80cab8dca90984a83.png";